import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, Autocomplete } from '@mui/material';

/**
 * Component for MyLaps tag selection with autocomplete
 */
const MyLapsTagField = ({ control, tagOptions }) => {
  return (
    <Controller
      name="mylapsTag"
      control={control}
      rules={{ required: 'MyLaps tag is verplicht' }}
      render={({ field, fieldState: { error } }) => {
        return (
          <Autocomplete
            freeSolo
            options={tagOptions}
            value={field.value || ""}
            onChange={(event, newValue) => {
              field.onChange(newValue);
            }}
            inputValue={field.value || ""}
            onInputChange={(event, newInputValue) => {
              field.onChange(newInputValue);
            }}
            renderInput={(params) => (
              <TextField 
                {...params}
                label="MyLaps Tag *"
                error={!!error}
                helperText={error ? error.message : ""}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        );
      }}
    />
  );
};

export default MyLapsTagField; 